import React, { useState } from "react";
import "./TableComponent.css";

function TableComponent({
  columns,
  students,
  placeholder,
  setSelectedStudents,
  selectedStudents,
}) {
  const handleSelectStudent = (id) => {
    setSelectedStudents(
      (prevSelectedStudents) =>
        prevSelectedStudents.includes(id)
          ? prevSelectedStudents.filter((studentId) => studentId !== id) // Uncheck (remove)
          : [...prevSelectedStudents, id] // Check (add)
    );
  };

  // Handle selecting/deselecting individual students
  // const handleSelectStudent = (email) => {
  //     setSelectedStudents((prevSelected) =>
  //         prevSelected.includes(email)
  //             ? prevSelected.filter((studentId) => studentId !== email) // Remove if already selected
  //             : [...prevSelected, email]
  //     );
  // };
  // Handle selecting/deselecting ALL students
  const handleSelectAll = () => {
    if (selectedStudents.length === students.length) {
      setSelectedStudents([]);
    } else {
      setSelectedStudents(students.map((student) => student.student._id));
    }
  };
  const isAllSelected =
    students.length > 0 && selectedStudents.length === students.length;

  return (
    <div
      className="table-container"
      style={{ overflowY: "scroll", height: "calc(100vh - 428px)" }}
    >
      <table className="custom-table">
        <thead
          style={{
            backgroundColor: "#ffd8be",
            position: "sticky",
            top: "0",
          }}
        >
          <tr>
            <th>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            </th>
            <th>Sr. No</th>
            <th>Roll Code</th>
            <th>Admission No</th>
            <th>Student Name</th>
            <th>Email</th>
            <th>Attendance</th>
          </tr>
        </thead>
        <tbody>
          {students && students.length > 0 ? (
            students?.map((student, index) => (
              <tr
                key={student?.student?._id}
                style={{
                  textAlign: "center",
                  backgroundColor: (index + 1) % 2 === 0 ? "#ececec" : "white",
                }}
              >
                <td>
                  <input
                    type="checkbox"
                    checked={selectedStudents.includes(student?.student?._id)}
                    onChange={() => handleSelectStudent(student?.student?._id)}
                  />
                </td>
                <td>{index + 1}</td>
                <td>{student?.student?.code}</td>
                <td>{student?.student?.addmissionNo}</td>
                <td>{student?.student?.name}</td>
                <td>{student?.student?.email}</td>
                <td>
                  {student?.attendancePercentage}% [{student?.presentDays} /{" "}
                  {student?.totalDays}]
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7}>No Result Foud</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TableComponent;
